import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import WheelView from '@/views/WheelAnalysis/WheelView.vue'
import RightSideBar from '@/components/RightSideBar/RightSideBar.vue'

import vueAwesomeSidebar from 'vue-awesome-sidebar'
import 'vue-awesome-sidebar/dist/vue-awesome-sidebar.css'
import 'mdb-vue-ui-kit/css/mdb.min.css'
import './assets/styles/styles.css'

import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { VueQueryPlugin } from '@tanstack/vue-query'

import {
    MDBRadio,
    MDBTextarea,
    MDBCheckbox,
    MDBFile,
    MDBInput,
    MDBAccordion,
    MDBAccordionItem,
    MDBTabs,
    MDBTabNav,
    MDBTabItem,
    MDBTabPane,
    MDBTabContent,
} from 'mdb-vue-ui-kit'

import { i18n, initLocale } from './i18n'

// jQuery globals (unchanged)
global.jQuery = require('jquery')
let $ = global.jQuery
window.$ = $

function initCookieConsent() {
    if (!window.cookieconsent || typeof window.cookieconsent.initialize !== 'function') return

    window.cookieconsent.initialize({
        // pull from Vue i18n
        getText: (key) => i18n.global.t(key),
    })
}

// if user switches language while banner is visible, rebuild it
function wireCookieConsentLocaleWatch() {
    if (!i18n?.global?.locale) return

    // vue-i18n v9: locale is a ref
    const localeRef = i18n.global.locale
    const originalValue = localeRef.value

    // Guard if ref isn't reactive
    if (typeof localeRef !== 'object' || !('value' in localeRef)) return

    let last = originalValue
    setInterval(() => {
        const current = localeRef.value
        if (current !== last) {
            last = current

            const existing = document.getElementById('cookieconsent-window')
            if (existing) {
                existing.remove()
                // allow re-init to rebuild markup
                window.cookieconsent.hasInitialised = false
                initCookieConsent()

            }
        }
    }, 300)
}

function bootstrap() {

    //const g = i18n.global

    const pinia = createPinia()
    pinia.use(piniaPluginPersistedstate)

    const app = createApp(App)

    app.use(i18n)

    app.config.globalProperties.$baseUrl = process.env.VUE_APP_BASE_URL
    app.config.globalProperties.$apiRoot = process.env.VUE_APP_API_ROOT

    // Global components
    app.component('WheelView', WheelView)
    app.component('RightSideBar', RightSideBar)

    app.component('MDBRadio', MDBRadio)
    app.component('MDBTextarea', MDBTextarea)
    app.component('MDBCheckbox', MDBCheckbox)
    app.component('MDBFile', MDBFile)
    app.component('MDBInput', MDBInput)
    app.component('MDBAccordionItem', MDBAccordionItem)
    app.component('MDBAccordion', MDBAccordion)
    app.component('MDBTabs', MDBTabs)
    app.component('MDBTabNav', MDBTabNav)
    app.component('MDBTabItem', MDBTabItem)
    app.component('MDBTabContent', MDBTabContent)
    app.component('MDBTabPane', MDBTabPane)

    app
        .use(router)
        .use(vueAwesomeSidebar)
        .use(pinia)
        .use(VueQueryPlugin)

    app.mount('#app')

    // Initialize cookie banner AFTER app + i18n are ready
    initCookieConsent()

     wireCookieConsentLocaleWatch()
}


initLocale().then(bootstrap)

